import Link from "next/link";

export default function MenuLink(props) {
  let { href, children, prefetch, ...rest } = props;
  return (
    <Link legacyBehavior href={href} prefetch={prefetch}>
      <a {...rest}>{children}</a>
    </Link>
  );
}
